import React from 'react';
import { BarChart3, CheckSquare, Clock, FileText, LayoutDashboard, Settings } from 'lucide-react';

export * from './permissionCountHelpers';
export * from './permissionDiffHelpers';

export const getScopeColor = (scope: 'basic' | 'management' | 'admin' | 'advanced'): string => {
  switch (scope) {
    case 'basic':
      return 'bg-success-100 text-success-600 dark:bg-success-900/20 dark:text-success-400';
    case 'management':
      return 'bg-info-100 text-info-600 dark:bg-info-900/20 dark:text-info-400';
    case 'admin':
      return 'bg-burntorange-100 text-burntorange-600 dark:bg-burntorange-900/20 dark:text-burntorange-400';
    case 'advanced':
      return 'bg-blueviolet-100 text-blueviolet-600 dark:bg-blueviolet-900/20 dark:text-blueviolet-400';
    default:
      return 'bg-neutral-100 text-neutral-600 dark:bg-neutral-900/20 dark:text-neutral-400';
  }
};

export const getIcon = (iconName: string, className?: string): React.ReactNode => {
  const iconProps = { className: className || 'h-5 w-5' };
  switch (iconName) {
    case 'LayoutDashboard': return <LayoutDashboard {...iconProps} />;
    case 'Clock': return <Clock {...iconProps} />;
    case 'FileText': return <FileText {...iconProps} />;
    case 'CheckSquare': return <CheckSquare {...iconProps} />;
    case 'BarChart3': return <BarChart3 {...iconProps} />;
    case 'Settings': return <Settings {...iconProps} />;
    default: return null;
  }
};
